import React, { useRef, useState, useEffect } from "react";
import { Prompt } from "react-router";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Switch,
  Select,
  message,
  Empty,
  Modal,
  Radio,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  Spin,
} from "antd";
import {
  getClientSuppById,
  editClientSupp,
  getNewClientSuppCode,
  getAllParents,
} from "../../services/clientSuppService";
import { ExclamationCircleOutlined, RetweetOutlined } from "@ant-design/icons";
import _t from "../../languages/translate";

const ItemForm = ({ onNewItem }) => {
  const IX_Code = useRef(null);
  const IX_Name = useRef(null);
  const [loading] = useState(false);
  const [form] = Form.useForm();
  let history = useHistory();
  let { id } = useParams();
  const { Option } = Select;

  //******************************//
  const [companyId] = useState(window.localStorage.getItem("comId"));
  const [isGoBack, setIsGoBack] = useState(true);
  const [parentChange, setParentChange] = useState(false);
  const [itemParentOpt, setItemParentOpt] = useState([]);
  const [proChange, setProChange] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [isGoParentId, setIsGoParentId] = useState(null);
  //******************************//

  const optionsWithDisabled = [
    { label: _t("strSub"), value: false },
    { label: _t("strMain"), value: true },
  ];

  const itemParentOptList =
    itemParentOpt.length > 0 &&
    itemParentOpt.map((item) =>
      item.id !== id ? (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ) : null
    );

  useEffect(() => {
    requestStatus(); // Request status | New | Child | Edit | 😆
    loadAllParents();
    IX_Name.current.focus();
  }, []);

  const loadAllParents = async () => {
    try {
      const { data: itemParentData } = await getAllParents();
      setItemParentOpt(itemParentData.data);
      setLoadData(false);
    } catch (error) {
      if (error.response) {
        message.error(error.response.data?.message || _t("msgUnknownError"), 3);
        setLoadData(false);
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
        setLoadData(false);
      } else {
        message.error(_t("msgUnknownError"), 3);
        setLoadData(false);
      }
    }
  };

  //******************************// //*******************// code number processes //*******************// //******************************//

  const codeGenerator = async (Id) => {
    const { data: newData } = await getNewClientSuppCode(Id);
    form.setFieldsValue({ code: newData.data.code, type: newData.data.type });
  }; //  To generate code by id

  const onChangeParent = async (value) => {
    if (parentChange === true) {
      Modal.confirm({
        title: `${_t("msgAskGenerateANewCode")}`,
        icon: <ExclamationCircleOutlined />,
        content: `${_t("msgGenerateANewCode")}`,
        okText: `${_t("strYes")}`,
        cancelText: `${_t("strNo")}`,
        async onOk() {
          setParentChange(false);
          codeGenerator(value);
          setProChange(true);
        },
        onCancel() {
          setProChange(true);
        },
      });
    } else {
      codeGenerator(value);
      setIsGoParentId(value);
    }
  };

  //******************************// //*******************// Editing processes //*******************// //******************************//

  useEffect(() => {
    async function fetchData() {
      if (id === "new" || id === "add") {
        return;
      }
      try {
        const { data } = await getClientSuppById(id);
        if (data.data.parentId === null) {
          data.data.parentId = undefined;
        }

        form.setFieldsValue({
          id: data.data.id,
          isMain: data.data.isMain,
          parentId: data.data.parentId,
          code: data.data.code,
          name: data.data.name,
          type: data.data.type,
          note: data.data.note,
          inactive: data.data.inactive,
          companyId: data.data.companyId,
        });
      } catch (error) {
        if (error.response) {
          message.error(
            error.response.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        } else if (error.request) {
          message.error(_t("msgServerDisconnected"), 3);
          setLoadData(false);
        } else {
          message.error(_t("msgUnknownError"), 3);
          setLoadData(false);
        }
      }
    }
    fetchData();
  }, [id, history]);

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsGoBack(true)}>
        {_t("strLeaveThePage")}
      </Menu.Item>
      <Menu.Item onClick={() => setIsGoBack(false)}>
        {_t("strStayInPage")}
      </Menu.Item>
    </Menu>
  );

  const goBack = () => {
    setProChange(false);
    if (isGoBack) {
      history.goBack();
    } else {
      if (id !== "new" && id !== "add") {
        history.replace({ ...history.location, pathname: "/clientsSupp/new" });
      }
      codeGenerator(isGoParentId);
      form.setFieldsValue({ name: "" });
      loadAllParents();
      IX_Name.current.focus();
    }
  };

  const requestStatus = () => {
    if (id === "new") {
      codeGenerator(null);
    } // if New item
    if (id === "add") {
      const parentId = history.location.state?.parentId;
      if (!parentId) return;
      codeGenerator(parentId);
      form.setFieldsValue({ parentId: parentId });
      setIsGoParentId(parentId);
    } // if Add child
    if (id !== "new" && id !== "add") {
      setParentChange(true);
    } // if Edit item
  };

  const handelChange = (value) => {
    const parentId = value.parentId;
    if (parentId) {
      history.replace({ ...history.location, state: { parentId } });
    }
  };

  const isMainChange = (e) => {
    setProChange(true);
  };

  const promptForm = () => {
    setProChange(true);
  };

  const onFinish = async (values) => {
    values.id = id;
    values.companyId = companyId;
    if (values.isMain === undefined) {
      values.isMain = false;
    }
    try {
      const data = await editClientSupp(values);
      message.success(data.data.message, 3);
      if (typeof onNewItem === "function") {
        onNewItem(data);
      } else {
        goBack();
      }
    } catch (error) {
      console.error(error.response);
      if (error.response) {
        if (error.response?.data?.data?.ex.includes("IX_Code")) {
          IX_Code.current.focus();
          message.error(
            error.response?.data?.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        } else if (error.response?.data?.data?.ex.includes("IX_Name")) {
          IX_Name.current.focus();
          message.error(
            error.response?.data?.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        } else {
          message.error(
            error.response?.data?.message || _t("msgUnknownError"),
            3
          );
          setLoadData(false);
        }
      } else if (error.request) {
        message.error(_t("msgServerDisconnected"), 3);
        setLoadData(false);
      } else {
        message.error(_t("msgUnknownError"), 3);
        setLoadData(false);
      }
    }
  };
  //******************************// //*******************// Form //*******************// //******************************//
  return (
    <div key="mainDiv">
      <React.Fragment>
        <Prompt when={proChange} message={_t("strUnsavedChanges")} />

        <div className="bg">
          <Spin spinning={loadData} tip={_t("strLoading")}>
            <Form
              form={form}
              name="itemform"
              onFinish={onFinish}
              layout="vertical"
              initialValues={{ isMain: false, type: 0 }}
              onValuesChange={handelChange}
            >
              <Row gutter={12}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={_t("strItemClassification")}
                    name="isMain"
                    hidden={typeof onNewItem === "function"}
                  >
                    <Radio.Group
                      buttonStyle="solid"
                      options={optionsWithDisabled}
                      onChange={isMainChange}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} />
                <Col xs={24} md={12}>
                  <Form.Item
                    name="parentId"
                    label={_t("strMainItem")}
                    rules={[{ required: false }]}
                  >
                    <Select
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      notFoundContent={
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty>
                      }
                      onChange={onChangeParent}
                      placeholder={_t("strNotSelected")}
                    >
                      {itemParentOptList}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="code"
                    label={_t("strCode")}
                    rules={[
                      {
                        required: true,
                        message: `${_t("strIsRequired")}`,
                      },
                      { min: 1, message: `${_t("strFrom3-200")}` },
                      { max: 200, message: `${_t("strFrom3-200")}` },
                    ]}
                  >
                    <Input
                      placeholder={_t("strCode")}
                      autoComplete="off"
                      maxLength={200}
                      onChange={promptForm}
                      ref={IX_Code}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="name"
                    label={_t("strName")}
                    rules={[
                      { required: true, message: `${_t("strIsRequired")}` },
                      { min: 1, message: `${_t("strFrom3-200")}` },
                      { max: 200, message: `${_t("strFrom3-200")}` },
                    ]}
                  >
                    <Input
                      placeholder={_t("strName")}
                      maxLength={200}
                      autoComplete="off"
                      onChange={promptForm}
                      ref={IX_Name}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="type"
                    label={_t("strType")}
                    rules={[
                      { required: true, message: _t("strFieldRequired") },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder={_t("strType")}
                      autoComplete="off"
                      onChange={promptForm}
                    >
                      <Option value={0}>{_t("strClientAndSupplier")}</Option>
                      <Option value={1}>{_t("strClient")}</Option>
                      <Option value={2}>{_t("strSupplier")}</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name="inactive"
                    valuePropName="checked"
                    label={_t("strInActive")}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <Space size="large">
                  <Button type="primary" htmlType="submit" disabled={loading}>
                    {_t("strSave")}
                  </Button>
                  <Dropdown.Button
                    hidden={typeof onNewStore === "function"}
                    overlay={menu}
                    onClick={() => history.goBack()}
                  >
                    {" "}
                    {_t("strBack")}
                  </Dropdown.Button>
                  {isGoBack ? (
                    <i />
                  ) : (
                    <RetweetOutlined style={{ fontSize: 21, marginTop: 5 }} />
                  )}
                </Space>
              </Form.Item>
            </Form>
          </Spin>
        </div>
      </React.Fragment>
    </div>
  );
};

export default ItemForm;
